import { createIcon } from '@chakra-ui/icons'

const JSIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#EFA163"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        JS
      </text>
      <g transform="translate(1 1.6)">
        <path
          fill="#E1E4EB"
          d="M-5256.6 4808.9h-32.9c-1.7 0-3.1-1.4-3.2-3.1V4776.1c0-1.7 1.4-3.1 3.1-3.2h33c1.7 0 3.1 1.4 3.2 3.1V4805.7c0 1.8-1.4 3.2-3.2 3.2.1 0 0 0 0 0zm-32.9-34.7c-1 0-1.9.8-1.9 1.8V4805.7c0 1 .8 1.9 1.8 1.9h33c1 0 1.9-.8 1.9-1.8V4776.1c0-1-.8-1.9-1.8-1.9h-33z"
        />
      </g>
      <g transform="translate(1 9.574)">
        <path
          fill="#E1E4EB"
          d="M-5254.1 4774.2h-38c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h38c.3 0 .6.3.6.6.1.4-.2.6-.6.6z"
        />
      </g>
      <g transform="translate(4.971 12.852)">
        <g transform="translate(0 1.231)">
          <path
            fill="#E1E4EB"
            d="M-5285.3 4791.4c-.2 0-.4-.1-.5-.3l-6.7-8.5c-.2-.2-.2-.5 0-.8l6.6-8.7c.2-.3.6-.3.9-.1.3.2.3.6.1.9l-6.3 8.3 6.4 8.1c.2.3.2.7-.1.9-.1.1-.3.2-.4.2z"
          />
        </g>
        <g transform="translate(23.301 1.275)">
          <path
            fill="#E1E4EB"
            d="M-5292 4791.3c-.1 0-.3-.1-.4-.1-.3-.2-.3-.6-.1-.9l6.4-8.2-6.4-8.1c-.2-.3-.2-.7.1-.9.3-.2.7-.2.9.1l6.6 8.5c.2.2.2.5 0 .8l-6.6 8.6c-.1.1-.3.2-.5.2z"
          />
        </g>
        <g transform="translate(10.192)">
          <path
            fill="#E1E4EB"
            d="M-5292 4795c-.1 0-.2 0-.3-.1-.3-.1-.5-.4-.4-.7v-.1l8.5-20.8c.1-.3.5-.5.8-.3s.5.5.3.8l-8.5 20.8c.1.3-.1.4-.4.4z"
          />
        </g>
      </g>
      <g transform="translate(5.493 3.625)">
        <path
          fill="#E1E4EB"
          d="M-5290.5 4774.2h-1.5c-.3 0-.6-.2-.6-.6v-.1c0-.3.2-.6.6-.6h1.6c.3 0 .6.2.6.6v.1c0 .3-.3.6-.7.6z"
        />
      </g>
      <g transform="translate(2.962 6.156)">
        <path
          fill="#E1E4EB"
          d="M-5292 4775.1c-.3 0-.6-.2-.6-.6v-1c0-.3.2-.6.6-.6h.1c.3 0 .6.2.6.6v1c-.1.4-.4.6-.7.6z"
        />
      </g>
      <g transform="translate(8.467 3.625)">
        <path
          fill="#E1E4EB"
          d="M-5284.4 4774.2h-7.7c-.3 0-.6-.2-.6-.6v-.1c0-.3.2-.6.6-.6h7.8c.3 0 .6.2.6.6v.1c0 .3-.3.6-.7.6.1 0 .1 0 0 0z"
        />
      </g>
    </g>
  ),
})

export default JSIcon
